export function isNull(input : string | undefined | null) {
    return (input === undefined || input === null || (input !==undefined && input !== null && (input.trim() === '')))
}